import { Component, OnInit, ViewChild, Injector, QueryList, ElementRef } from '@angular/core';
import saveAs from 'file-saver';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { Global } from 'src/app/Global';
import { CommonService } from 'src/app/shared/common.service';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { LocationService } from 'src/app/shared/location.service';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { EmployeeRecoveryService } from 'src/app/shared/employee-recovery.service';
// import { PayrollVoucherService } from 'src/app/shared/journal-voucher.service';
import { JournalVoucherService } from 'src/app/shared/journal-voucher.service';
import { AlertService } from 'src/app/common/alert.service';
import { SelectionModel } from '@angular/cdk/collections';
// import { isUndefined } from 'util';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-generate-journal-voucher',
  templateUrl: './generate-journal-voucher.component.html',
  styleUrls: ['./generate-journal-voucher.component.css'],
  // standalone: true,
  // imports:[MatPaginatorModule,DropdownModule,FormsModule,MatTableModule
  //   ,MatCardModule,ReactiveFormsModule,CommonModule]
})
export class GenerateJournalVoucherComponent implements OnInit {
/***********************************Declare Private Properties************************/
EmployeeRecoveryRecordsForm: UntypedFormGroup;
private alertService: AlertService;
isLoadingResults = false;
FirmList:any;
ReportedLocationList:any;
ShowJV:boolean;
ReqID:UntypedFormArray;
LocationDataSource: MatTableDataSource<any[]>;
displayedColumns = ['chk','RecordID', 'UserName', 'UserEmail','UserLocation','ReportedLocation','AssetType','PenaltyType','PenaltyAmount','Status'];


@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
@ViewChild(MatSort, { static: true }) sort: MatSort;
@ViewChild("chkBox", { static: true }) private chkBoxes: QueryList<ElementRef>;
selection = new SelectionModel<any[]>(true, []);
/******************************************END***************************************/

constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
  public _commonService: CommonService, private error: AppErrorHandler,
  private _locationService: LocationService, injector: Injector,
  private status: HTTPStatus,
  private _EmployeeRecovery:EmployeeRecoveryService,
  private _journalVoucher:JournalVoucherService) { this.alertService = injector.get(AlertService); }
  // private _PayrollVoucher:PayrollVoucherService) { this.alertService = injector.get(AlertService); }


ngOnInit() {
  this.paginator.showFirstLastButtons = true;
  this.paginator.pageSize = this._global.RecordSize;
  this.ShowJV=false;
  this.EmployeeRecoveryRecordsForm = this._fb.group({            
    entityid: [''],    
    ReportedLocationID: [''],    
    CreatedBy:[],   
    Checked:Boolean,
    ReqID:[],
    PageNumber: (this._global.pageIndex)
  });  
  this.BindFirmTypeList();
  this.BindReportedLocationList();  
}
  
  isAllSelected() {    
    if(this.LocationDataSource ===undefined) 
    return;
    if(this.LocationDataSource!==undefined && this.LocationDataSource!==null){
      const numSelected = this.selection.selected.length;
      const numRows = this.LocationDataSource.data.length;     
      return numSelected === numRows;      
    }    
  }
 selectRow($event, dataSource) {    
     if ($event.checked) {     
       dataSource.Checked=true;
     }
     else if($event.checked==false){      
       dataSource.Checked=false;      
     }
   }

 
  masterToggle($event) { 
    if ($event.checked) {
      this.onCompleteRow(this.LocationDataSource);
    }
    this.isAllSelected() ?
        this.selection.clear() :        
        this.LocationDataSource.data.forEach(row => this.selection.select(row));       
  }
BindFirmTypeList() {
  this._commonService.BindDropDown('Firm').subscribe(result => {    
    this.FirmList = result;
  });
}
onCompleteRow(dataSource) {
  dataSource.data.forEach(element => {   
    element.Checked=true;
  });
}

BindReportedLocationList() {
  this._commonService.BindDropDown('Location').subscribe(result => {
    this.ReportedLocationList = result;
  });
}

SearchJVRecord() { 
  this._global.pageIndex = 1;
  this._global.length = 0;
  this._global.totalPage = 0;
  this.EmployeeRecoveryRecordsFormList();
}

EmployeeRecoveryRecordsFormList() {
  
  this.status.setHttpStatus(true);
  if(this.EmployeeRecoveryRecordsForm.controls.entityid.value==null ||this.EmployeeRecoveryRecordsForm.controls.entityid.value=="")
  {
    alert('Please select entity type.');
    this.status.setHttpStatus(false);
    return;
  }
  this.EmployeeRecoveryRecordsForm.controls.PageNumber.setValue(this._global.pageIndex - 1);
  this._journalVoucher.GetAllEmployeeRecoveryFinanceJVList(this.EmployeeRecoveryRecordsForm.value).subscribe(data => {
    
    if (data.RequestData != null && data.RequestData.length > 0) {      
      this.LocationDataSource = new MatTableDataSource(data.RequestData);
      if (this._global.length === 0) {
        this._global.length = data.TotalRecordCount;
        this.LocationDataSource.paginator = this.paginator;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
        this.LocationDataSource.sort = this.sort;
        this.ShowJV=true;
      } else {
        this.paginator.pageIndex = this._global.pageIndex - 1;
        this.status.setHttpStatus(false);
         this.ShowJV=true;
      }
    } else {
      this.LocationDataSource = new MatTableDataSource(data.RequestData);
      this._global.length = data.TotalRecordCount;
      this.paginator.pageSize = this._global.RecordSize;
      this._global.pageIndex = 1;
      this._global.totalPage = 0;
    }
  }, (error) => {
    this.status.setHttpStatus(false);
    this.error.handleError(error);
  }, () => {  this.status.setHttpStatus(false); });
}

Reset() {
  this.EmployeeRecoveryRecordsForm.reset();  
}

// ******************************************Pagging*************************************//
onPaginateChange(e: any) {
  this._global.pageIndex = (e.pageIndex + 1);
  this.EmployeeRecoveryRecordsFormList();
}

ConfirmationAlert(){

  // if (confirm('Are you sure you want to generate Journal Vouchers for selected records')) 
  
  if (confirm('Are you sure you want to Send To Payroll For Recovery for selected records')) {
    // this.GenerateJournalVoucher();
    this.SendToPayrollForRecovery();
}
}

SendToPayrollForRecovery(){
    // if(this.LocationDataSource.data==null && this.LocationDataSource.data.length==0)
    // {
    //   alert('Please Select Record ID.');
    //   return;
    // }
    
    let RecoveryIDList=[];
    for(let i=0;i<=this.LocationDataSource.data.length-1;i++)
    {
      if(this.LocationDataSource.data[i]["Checked"] == true){
        RecoveryIDList.push(this.LocationDataSource.data[i]["recdid"]);
      }
    }
    this.status.setHttpStatus(true);
    this.EmployeeRecoveryRecordsForm.controls.ReqID.setValue(RecoveryIDList);
    this._journalVoucher.GenerateJournalVoucher(this.EmployeeRecoveryRecordsForm.value).subscribe(data => {
      if (data.RequestMessage!==null) {         
          alert(data.RequestMessage);   
          this._router.navigate(['Finance/view-recovery']);       
      } else {
        //this.alertService.notify('warn', 'warn!', );
        alert(data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
}


GoToPage() {
  if (this._global.pageIndex <= 0) { this._global.pageIndex = 1; } else if
    (this._global.pageIndex > this._global.totalPage) {
    this._global.pageIndex = this._global.totalPage;
  }
  this.EmployeeRecoveryRecordsFormList();
}

Export() {  
  this._EmployeeRecovery.RecoveryExportData(this.EmployeeRecoveryRecordsForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'EmployeeRecoveryDetails.xls');
  });
}

// **************************************Pagging End*************************************//
}
